import { Separator } from '@natu/ui/Decorators/Separator';

import {
  type SBProps,
  type StoryblokPalette,
  sbEditable,
  type Spacing,
  resolveStoryblokStyles,
} from '../../../../utils';

interface SBSeparatorProps {
  color?: StoryblokPalette;
  orientation?: 'horizontal' | 'vertical';
  mt?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mb?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}

export const SBSeparator = ({ blok }: SBProps<SBSeparatorProps>) => {
  const {
    color,
    orientation = 'horizontal',
    mt,
    mtTablet,
    mtDesktop,
    mb,
    mbTablet,
    mbDesktop,
  } = blok;

  const className = resolveStoryblokStyles({
    mt,
    mtTablet,
    mtDesktop,
    mb,
    mbTablet,
    mbDesktop,
    className: color?.value ? 'bg-[var(--bg-sb-color)]' : undefined,
  });

  const style = color?.value
    ? ({ '--bg-sb-color': color?.value } as React.CSSProperties)
    : undefined;

  return (
    <Separator
      orientation={orientation}
      className={className}
      style={style}
      {...sbEditable(blok)}
    />
  );
};
